// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.is-outside-current-month .pika-button{\n    pointer-events: auto !important;\n}\n", ""]);
// Exports
module.exports = exports;
